import { useMelwaysInfo } from '@seek/melways-react';

import { useTypedSelector } from 'src/reducers';

// Constructs the locale string from the language and country.
// Example: en-AU, id-ID, th-TH, etc.
export const useGetLocale = () => {
  const { language } = useMelwaysInfo();
  const country = useTypedSelector(
    (state) => state.page.pageAnalytics.siteCountry,
  ).toUpperCase();

  return `${language}-${country}`;
};
